<template>
  <div class="controls">
    <span>
      <span v-if="storeAnswer.checked">
        <span class="value-container" v-if="value.text_enabled !== true">
          {{$tr(value, 'label')}}
        </span>
        <span class="value-container" v-if="value.text_enabled === true && !storeAnswer.data.value">
          {{$tr(value, 'label')}}
        </span>
        <span class="value-container" v-if="value.text_enabled === true && storeAnswer.data.value">
          {{$tr(value, 'label')}} - {{storeAnswer.data.value}}
        </span>
        <span v-if="value.timespan_enabled === true">
          : {{storeAnswer.data.start_entry}} - {{storeAnswer.data.end_entry}}
        </span>
      </span>
    </span>
  </div>
</template>
<script>
import mixin from './_mixin_display'
import { EmptyAnswer } from './_mixin_display_base';
export default {
  mixins: [mixin],
  props: {
    value: {},
    index: {},
  },
  skipBasic: true,
  computed: {
    storeAnswer(){
      return this.allAnswers.find(a=>a.option_id===this.value.option_id) || EmptyAnswer
    },
  },
  created(){
    this.answer = this.checkboxAnswerInit(this.field, this.value.option_id, this.form_result)
  },
}
</script>